<style lang="scss" scoped>
.img-upload {
  .upload-item {
    display: inline-block;

    position: relative;

    width: 2.2rem;
    height: 1.6rem;
    margin-right: 0.14rem;

    background: #fff;

    border-radius: 0.08rem;
    border: 0.04rem dashed #f0f0f0;

    vertical-align: top;

    img {
      width: 100%;
      height: 100%;
    }

    .curr {
      display: none;
    }

    &.show-img {
      border: 0 none;
    }
    &.curr-item {
      background-color: #f0f0f0;
      border: 0 none;
      .curr {
        display: block;

        width: 100%;
        height: 100%;
        padding-top: 0.4rem;

        font-size: 0.24rem;
        color: #fff;
        .cross {
          display: block;

          position: relative;

          width: 0.5rem;
          height: 0.5rem;
          margin: 0 auto;

          &:after {
            position: absolute;

            top: 0;
            right: 0;
            left: 0;

            width: 0.06rem;
            height: 100%;
            margin: auto;

            background-color: #fff;
            border-radius: 0.69rem;

            content: '';
          }

          &:before {
            position: absolute;

            top: 0;
            right: 0;
            bottom: 0;

            width: 100%;
            height: 0.06rem;
            margin: auto;

            background-color: #fff;
            border-radius: 0.69rem;

            content: '';
          }
        }
        p {
          margin-top: 0.08rem;

          text-align: center;
        }
      }
    }
  }
}

.file-uploader {
  display: none;
}

.close-btn {
  position: absolute;
  top: -0.1rem;
  right: -0.1rem;

  width: 0.4rem;
  height: 0.4rem;

  border-radius: 0.4rem;

  font-size: 0.14rem;
  line-height: 0.4rem;
  font-weight: bold;
  text-align: center;
}
</style>

<template>
  <div class="img-upload">
    <div
      v-for="(pic, index) in pics"
      :key="pic.id"
      class="upload-item"
      :class="{
        'curr-item': pic.canUpload && !pic.fileUrl,
        'show-img': pic.fileUrl
      }"
      @click="addPhoto(pic, index)"
    >
      <div class="curr">
        <span class="cross"></span>
        <p>最多3张</p>
      </div>
      <img
        v-if="pic.fileUrl"
        :src="adaptOssImage(pic.fileUrl, resl)"
        @error="imgLoadFail"
      />
      <div v-show="pic.fileUrl" class="close-btn" @click.stop="delPhoto(index)">
        <IconFont
          name="mc-icon-guanbi"
          size="14px"
          color="#666"
          class="icon-font"
        ></IconFont>
      </div>
    </div>
    <input
      ref="uploader"
      type="file"
      class="file-uploader"
      accept="image/*"
      @change="onFileChange"
    />
  </div>
</template>

<script>
import { ossImage, imgLoadFail, onLoadP } from '@/utils/oss_image'
const MAX_UPLOAD = 3

export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['ossData'],
  data() {
    const pics = []
    for (var i = 0, len = MAX_UPLOAD; i < len; i++) {
      pics.push({
        id: i,
        fileId: '',
        fileUrl: '',
        canUpload: i === 0
      })
    }
    return {
      pics: pics,
      // eslint-disable-next-line camelcase
      // resl: Math.floor( * 2.2 * 4)
      resl: 440
    }
  },
  methods: {
    imgLoadFail,
    adaptOssImage(src, width = 0, height = 0) {
      return ossImage({
        src,
        width,
        height
      })
    },
    init() {
      this.pics = []
      for (var i = 0, len = MAX_UPLOAD; i < len; i++) {
        this.pics.push({
          id: i,
          fileId: '',
          fileUrl: '',
          canUpload: i === 0
        })
      }
    },
    async onFileChange(e) {
      const file = e.target.files[0]

      // const { name, type } = file
      if (file) {
        this.$Loading()
        const ossData = this.ossData
        try {
          const data = await onLoadP({
            ossData,
            file,
            path: ''
          })
          this.$Loading.hide()
          this.updateImg(data)
        } catch (error) {
          this.$Loading.hide()
          if (error.message) {
            this.$toast(error.message)
          } else if (
            'status' in error &&
            'headers' in error &&
            'body' in error &&
            error.status === 413
          ) {
            this.$toast('图片尺寸过大，上传失败')
          } else {
            this.$catch(error)
          }
        }
      }
    },
    updateImg(img) {
      const currPic = this.pics[this.currPicIndex]
      const pic = img.data
      currPic.fileId = '/' + pic.fid
      currPic.fileUrl = pic.furl
      if (this.pics.length - 1 > this.currPicIndex) {
        this.pics[this.currPicIndex + 1].canUpload = true
      }
      this.updateFile()
    },
    addPhoto(item, index) {
      if (item.canUpload) {
        this.currPicIndex = index
        this.$refs.uploader.click()
      }
    },
    delPhoto(index) {
      const pic = this.pics[index]
      // this.pics.remove(pic)
      // this.pics.push(pic)
      pic.fileId = ''
      pic.fileUrl = ''
      pic.canUpload = false

      index = -1
      this.pics.forEach((pic, idx) => {
        if (!pic.fileId && index < 0) {
          pic.canUpload = true
          index = idx
        } else if (!pic.fileId) {
          pic.canUpload = false
        }
      })
      this.updateFile()
    },
    updateFile() {
      this.$nextTick(() => {
        if (this.$refs.uploader) {
          this.$refs.uploader.value = ''
        }

        this.$emit(
          'update:pics',
          this.pics.filter(pic => pic.fileId).map(pic => pic.fileId)
        )
      })
    }
  }
}
</script>
